import { create } from "zustand";
import { persist } from "zustand/middleware";
import type { BudgetReceiptMethodId } from "./types";

export interface AppliedBudgetScope {
  /** Map of additional service id → enabled. Required services are not stored here. */
  services: Record<string, boolean>;
  receiptMethod: BudgetReceiptMethodId;
  /** ISO date when the user applied this scope — drives the "Обновлено" line. */
  appliedAt: string;
}

interface BudgetScopeState {
  /** Per-shipment overrides. Absent = budget is in its baseline state. */
  overrides: Record<string, AppliedBudgetScope>;
  setScope: (shipmentId: string, scope: AppliedBudgetScope) => void;
  clearScope: (shipmentId: string) => void;
}

/**
 * Holds user-applied scope-of-services changes per shipment.
 * Persisted to localStorage so the revised budget survives a refresh — without
 * polluting the main app store with prototype-only state.
 */
export const useBudgetScopeStore = create<BudgetScopeState>()(
  persist(
    (set) => ({
      overrides: {},
      setScope: (shipmentId, scope) =>
        set((state) => ({
          overrides: { ...state.overrides, [shipmentId]: scope },
        })),
      clearScope: (shipmentId) =>
        set((state) => {
          const next = { ...state.overrides };
          delete next[shipmentId];
          return { overrides: next };
        }),
    }),
    { name: "wl-budget-scope-overrides" },
  ),
);
